import { render, staticRenderFns } from "./GrnItems.vue?vue&type=template&id=24343280&scoped=true"
import script from "./GrnItems.vue?vue&type=script&lang=js"
export * from "./GrnItems.vue?vue&type=script&lang=js"
import style0 from "./GrnItems.vue?vue&type=style&index=0&id=24343280&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24343280",
  null
  
)

export default component.exports